import React from 'react';
import { useInvoiceStore } from '../../../store/invoiceStore';
import { Link } from 'react-router-dom';
import { Badge } from '../../../components/Badge';
import { Button } from '../../../components/Button';
import { Card, CardContent } from '../../../components/Card';

export function InvoiceList() {
  const { invoices, fetchInvoices, isLoading } = useInvoiceStore();

  React.useEffect(() => {
    fetchInvoices();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="tracking-tight text-foreground font-display text-page-title">Invoices</h1>
          <p className="text-muted-foreground mt-1">Manage all invoices</p>
        </div>
        <Link to="/money/invoices/new">
          <Button variant="primary">+ Create Invoice</Button>
        </Link>
      </div>

      <Card>
        <CardContent className="p-0">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-card">
                <tr>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Invoice #</th>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Customer</th>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Amount</th>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Status</th>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Due Date</th>
                  <th className="text-left py-4 px-6 text-sm font-semibold text-muted-foreground">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border-12">
                {invoices.map((invoice) => (
                  <tr key={invoice.id} className="hover:bg-card/50 transition-colors">
                    <td className="py-4 px-6 text-foreground font-mono">{invoice.invoiceNumber}</td>
                    <td className="py-4 px-6 text-foreground">{invoice.customerName}</td>
                    <td className="py-4 px-6 text-foreground">${invoice.totalAmount.toLocaleString()}</td>
                    <td className="py-4 px-6">
                      <Badge variant={
                        invoice.status === 'paid' ? 'success' :
                        invoice.status === 'overdue' ? 'error' :
                        invoice.status === 'sent' ? 'info' : 'default'
                      }>
                        {invoice.status}
                      </Badge>
                    </td>
                    <td className="py-4 px-6 text-muted-foreground">
                      {new Date(invoice.dueDate).toLocaleDateString()}
                    </td>
                    <td className="py-4 px-6">
                      <Link
                        to={`/money/invoices/${invoice.id}`}
                        className="text-primary hover:text-primary text-sm font-medium"
                      >
                        View →
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
